import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

window.addEventListener("DOMContentLoaded", (event) => {
	var swipers = document.querySelectorAll(".nhr-list-card-swiper");

	for (const swiper of swipers) {

		swiper.classList.add("swiper");
		const slidesPerView = swiper.getAttribute("data-slides-per-view");
		const spaceBetween = swiper.getAttribute("data-space-between");
		const speed = swiper.getAttribute("data-speed");
		const effect = swiper.getAttribute("data-effect");
		const autoHeight = swiper.getAttribute("data-auto-height") === "true";
		const loop = swiper.getAttribute("data-loop") === "true";
		const autoplay = swiper.getAttribute("data-autoplay") === "true";
		const autoplayDelay = swiper.getAttribute("data-autoplay-delay");
		const navigation = swiper.getAttribute("data-navigation") === "true";
		const pagination = swiper.getAttribute("data-pagination") === "true";
		const bulletClickable =
			swiper.getAttribute("data-bullet-clickable") === "true";
		const scrollbar = swiper.getAttribute("data-scrollbar") === "true";
		const scrollbarHide = swiper.getAttribute("data-scrollbar-hide") === "true";
		const scrollbarDraggable =
			swiper.getAttribute("data-scrollbar-draggable") === "true";
		new Swiper(swiper, {
			modules: [Navigation, Pagination, Autoplay],
			autoHeight: autoHeight,
			autoplay: autoplay
				? {
						delay: autoplayDelay,
				  }
				: false,
			loop: loop,
			direction: "horizontal",
			navigation: navigation
				? {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
				  }
				: false,
			pagination: pagination
				? {
						el: ".swiper-pagination",
						clickable: bulletClickable,
				  }
				: false,
			scrollbar: scrollbar
				? {
						el: ".swiper-scrollbar",
						hide: scrollbarHide,
						draggable: scrollbarDraggable,
				  }
				: false,
			// Optional parameters

			slidesPerView: slidesPerView,
			spaceBetween: spaceBetween,
			speed: speed,
		});
	}
});
